const CONTENT_NODE_TYPES = ['start', 'finish'];

export const isEmptyScheme = (scheme) => {
    if (!scheme || !Array.isArray(scheme.scheme)) {
        return false;
    }

    const contentBlocks = scheme.scheme.filter(
        (el) => !el.source && !CONTENT_NODE_TYPES.includes(el.type)
    );

    return contentBlocks.length === 0;
};
